/* global axios */
// import ApiClient from './ApiClient';
import CacheEnabledApiClient from './CacheEnabledApiClient';

export class TeamsAPI extends CacheEnabledApiClient {
  constructor() {
    super('teams', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'team';
  }

  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }

  getAgents({ teamId }) {
    return axios.get(`${this.url}/${teamId}/team_members`);
  }

  // NOTICE: KAPTION-INTEGRATION
  // group-visibility.API.4 — optional leadersList marks which user_ids get the
  // leader role (Secure Assignment Mode). Omitted → backend keeps roles untouched.
  addAgents({ teamId, agentsList, leadersList }) {
    return axios.post(`${this.url}/${teamId}/team_members`, {
      user_ids: agentsList,
      ...(leadersList ? { leader_ids: leadersList } : {}),
    });
  }

  updateAgents({ teamId, agentsList, leadersList }) {
    return axios.patch(`${this.url}/${teamId}/team_members`, {
      user_ids: agentsList,
      ...(leadersList ? { leader_ids: leadersList } : {}),
    });
  }
}

export default new TeamsAPI();
